// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__56pT0","index":"styles_index__1d0tF"};